import { ApiErrorResponse } from "../../types";
import { errorIsFromApi } from "../errorIsFromApi";
import { navigateToAdmin } from "../navigateToAdmin";

export async function postRequestWrapper<Body, Response>({
  url,
  body,
}: {
  url: string;
  body?: Body;
}): Promise<Response> {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  });

  if (!response.ok) {
    const error: unknown = await response.json();

    // TODO - Add functionality to detect error type and print error.
    if (errorIsFromApi(error)) {
      const {
        error: { message, code },
      }: ApiErrorResponse = error as ApiErrorResponse;

      console.log(error);

      if (code === -100) {
        // Authentication failed.
        navigateToAdmin();
      }

      throw new Error(`Api Responsed with an error: ${code}: ${message}`);
    }

    throw new Error(`Error encountered when making POST request to "${url}"`);
  }

  return response.json() as Response;
}
